import { c as _c } from "react/compiler-runtime";
type TimelineEvent = {
  id: string;
  timestamp: string;
  title: string;
  description?: string;
};
type TimelineProps = {
  title?: string;
  events: TimelineEvent[];
};
const Timeline = t0 => {
  const $ = _c(13);
  const {
    title,
    events: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const events = t2;
  let t3;
  if ($[2] !== title) {
    t3 = title && <span className="text-label-2 text-primary fp-text">{title}</span>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== events) {
    let t5;
    if ($[6] !== events.length) {
      t5 = (event, i) => {
        const isLast = i === events.length - 1;
        return <li key={event.id} className="grid grid-cols-[1rem_minmax(0,1fr)] gap-x-3 gap-y-0.5 md:flex md:gap-3"><p className="col-start-2 row-start-1 flex h-5 shrink-0 items-center text-snippet-2 text-tertiary fp-text md:w-24">{event.timestamp}</p><div className="relative col-start-1 row-span-2 row-start-1 flex w-4 shrink-0 flex-col items-center"><span aria-hidden="true" className="flex h-5 items-center"><span className="h-2.5 w-2.5 rounded-full bg-neutral-inverted" /></span>{!isLast && <span aria-hidden="true" className="absolute bottom-0 left-1/2 top-5 w-px -translate-x-1/2 bg-senary" />}</div><div className={`col-start-2 row-start-2 flex min-w-0 flex-1 flex-col gap-1 ${isLast ? "" : "pb-7"}`}><p className="text-body-2 text-primary fp-text">{event.title}</p>{event.description && <p className="text-body-2 text-tertiary fp-text">{event.description}</p>}</div></li>;
      };
      $[6] = events.length;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t4 = events.map(t5);
    $[4] = events;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <ol className="flex flex-col">{t4}</ol>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex flex-col gap-3 w-full">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default Timeline;